import React from "react";

import ChatLanguages from "./Languages";
import TemplateList from "./TemplateList";

/**
 * Everything about the Teams / Google Chat arrival message: the languages it is written in
 * and, per arrival type, its text. ADMIN only — we configure it for the client. A text is
 * edited on its own page (`TemplateEditor`, routed in `pages/Clients/index.tsx`).
 */
const ChatMessages = () => (
  <>
    <ChatLanguages />
    <TemplateList />
  </>
);

export default ChatMessages;
